export const POKUS_SEO_PREFILL_AB = 'SEO_Prefill_AB';
export const SEO_PREFILL_AB_ENABLED = 'SEO_Prefill_AB_Enabled';
export const SEO_PREFILL_AB_DISABLED = 'SEO_Prefill_AB_Disabled';
export const POKUS_SEO_PREFILL_DEFAULT = true;
export const CABS_POKUS = 'cabs_pokus';
export const CABS_LANDING_SNACKBAR = 'LandingPage_SnackBar';
